export const getTimeZone = async () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};
